import axios from 'axios';
import shouldAddCors from '../helpers/shouldAddCors';

let API = process.env.REACT_APP_BACKEND_HOST + '/api/users';

// API = shouldAddCors(API);
// console.log({ API });

const loanEligibilty = axios.create({
  baseURL: API,
});

loanEligibilty.defaults.headers.post['Content-Type'] = 'application/json';
loanEligibilty.defaults.headers['Access-Control-Allow-Origin'] = '*';

export default loanEligibilty;
